// extracted by mini-css-extract-plugin
export default {"smart-search-content":"sD24JCqM4yFN0xnq_l2R","tip":"uqOFGA4EXb4L7xXccjN2","body":"NVJHW7BIL3Caw2RDjK1c"};